import React from "react";
import { Box, Typography } from "@mui/material";

const GlobalDescription = ({
  subTitle,
  label,
  subLabel,
  name,
  description,
}) => {
  return (
    <>
      {subTitle ? (
        <Box sx={[styles.RootContainer]}>
          <Typography
            variant="subtitle1"
            color="text.secondary"
            sx={[styles.SubHeadingTxt]}
          >
            {subTitle}
          </Typography>
        </Box>
      ) : label && subLabel ? (
        <Box sx={[styles.RootContainer]}>
          <Typography variant="body1" sx={[styles.SubHeadingTxt]}>
            <strong>{label}</strong> {subLabel}
          </Typography>
        </Box>
      ) : (
        <Box sx={styles.RootContainer}>
          <Typography
            variant="body1"
            sx={{
              ...styles.SubHeadingTxt,
              display: "flex",
              alignItems: "center",
              flexDirection: "row",
            }}
          >
            <Box component="strong" sx={{ mr: 1 }}>
              {name}
            </Box>
            {description}
          </Typography>
        </Box>
      )}
    </>
  );
};

export default GlobalDescription;

const styles = {
  RootContainer: { padding: "0px px" },

  SubHeadingTxt: {
    color: "black",
    fontWeight: "400",
    alignItems: "center",
    // textAlign: "center",
    textAlign: "left",
    fontFamily: '"Poppins", serif',
    width: { xs: "100%", sm: "100%", md: "94%" },
    fontSize: { xs: "0.9rem", sm: "0.9rem", md: "0.96rem" },
  },
};
